'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function parseLocale(locale) {
    if (!locale) {
        locale = 'en-US';
    }
    var parsed = locale.split(/[-_]/);
    var lang = parsed[0].toLowerCase();
    var country = undefined;
    if (lang === 'jp') {
        lang = 'ja';
    }
    if (parsed.length >= 2 && parsed[1].length !== 0) {
        country = parsed[parsed.length - 1].toUpperCase();
    }
    else {
        country = lang.toUpperCase();
        switch (country) {
            case 'CS':
                country = 'CZ';
                break;
            case 'DA':
                country = 'DK';
                break;
            case 'EL':
                country = 'GR';
                break;
            case 'EN':
                country = 'US';
                break;
            case 'HE':
                country = 'IL';
                break;
            case 'JA':
                country = 'JP';
                break;
            case 'KO':
                country = 'KR';
                break;
            case 'SL':
                country = 'SI';
                break;
            case 'SV':
                country = 'SE';
                break;
            case 'ZH':
                country = 'CN';
                break;
        }
    }
    return {
        country: country,
        lang: lang,
        locale: lang + "-" + country,
    };
}
function localizeUrl(url, opts) {
    var customLocaleMap = {
        'ja-JP': 'jp',
    };
    if (!opts) {
        opts = {};
    }
    var path = url;
    var inputLocale = opts.locale || '';
    var baseUrl = opts.baseUrl || '';
    var query = opts.query;
    var qstring = '';
    var baseUrlPresent = url.match(/^(http(s)?:)?\/\//);
    var _a = parseLocale(inputLocale), country = _a.country, locale = _a.locale;
    baseUrl = country === 'CN' ? baseUrl.replace('.com', '.cn') : baseUrl.replace('.cn', '.com');
    if (baseUrlPresent) {
        baseUrl = '';
    }
    if (inputLocale.indexOf('_') === 2) {
        locale = locale.replace('-', '_');
    }
    if (!locale || ['US', 'CN'].indexOf(country) >= 0) {
        locale = '';
    }
    else if (customLocaleMap[locale]) {
        locale = customLocaleMap[locale];
    }
    path = path.replace(/^\/?([a-z]{2}[-_][a-z]{2}|jp)/i, '');
    var parts = [
        baseUrl,
        locale && locale.replace('-', (opts && opts.delimiter) || '-'),
        path,
    ].filter(function (part) { return part; });
    var result = '';
    for (var i = 0; i < parts.length; i++) {
        var part = parts[i];
        if (part) {
            if (baseUrlPresent || (baseUrl && i === 0)) {
                part = part.replace(/\/$/g, '');
            }
            else {
                part = part.replace(/^\/|\/$/g, '');
            }
            result += part;
            if (i < parts.length - 1) {
                result += '/';
            }
        }
    }
    if (!baseUrlPresent && (!baseUrl || (baseUrl.length === 0 && result.substring(0, 1) !== '/'))) {
        result = '/' + result;
    }
    if (query) {
        for (var p in query) {
            qstring += p + '=' + query[p] + '&';
        }
        if (qstring.length) {
            result += '?' + qstring.substring(0, qstring.length - 1);
        }
    }
    return result;
}

exports.localizeUrl = localizeUrl;
exports.parseLocale = parseLocale;
